import apiClient from "@/lib/api/client";
import { languageController } from "./config";
import {
  fetchPreLoginLanguagePolicy,
  readLanguagePolicy,
} from "./language-policy";

// When the language policy is applied: the session user's settings on login,
// refresh and app start with a session; the host's pre-login defaults
// otherwise (see auth-session.store.js).

export const applyUserLanguagePolicy = (user) =>
  user
    ? languageController.applyPolicy(readLanguagePolicy(user))
    : languageController.whenSettled();

export const loadPreLoginLanguagePolicy = async () => {
  const policy = await fetchPreLoginLanguagePolicy((url, options) =>
    apiClient.get(url, options),
  );
  return languageController.applyPolicy(policy);
};

export const chooseLanguage = (code) => languageController.chooseLanguage(code);

export const whenLanguageSettled = () => languageController.whenSettled();
